import { settings } from '../../../settings/settings-util';
import reducer from './reducers';
import * as postMessageUtilities from '../../lib-postmessage/lib/lib-postmessage';
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';
import {AlmeState} from "../../../wireup/AlmeState";
import {Reducer, Store} from "redux";
import {forceIsActiveSession} from "../../appevent-welcomeuser-onlaunch/src/actions/actions";
import {LaunchIva, PrepareLaunchParameters, SetCustomSessionId} from "./actions/Actions";
import { AlmeUIInput } from '../../../types/input';
import {setMinimize} from "../../window-minimize/src/actions/actions";

export type IvaPostMessage = {
    accessKey?: string;
    createDateTime?: string;
    id?: string;
    isProcessed?: boolean;
    launchKey?: string;
    launchParameter?: string;
    launchPointName?: string;
    launchQuestion?: string;
    launchType?: string;
    language?: string;
    source?: string;
    type: string;
    userData?: Record<string, unknown>;
    customSid?: string;
};

type LaunchPostMessageObject = {
    message: IvaPostMessage;
}


/**
 * LaunchMessageProcessor is responsible for processing the LaunchIva message
 * received from the ClientCommunicator. It also removes the message after it is processed.
*/
export default class LaunchMessageProcessor
{
    _settings: typeof settings;
    _store: Store<AlmeState> | null = null;
    _initializationPromises;

    constructor(passedSettings?: typeof settings)
    {
        this._settings = passedSettings ?? settings;
    }

    static getDefaultSettings(): typeof settings
    {
        return settings;
    }

    getReducer(): Reducer<AlmeState>
    {
         return reducer;
    }

    initialize(store, initPromise): void
    {
        this._store = store;
        this._initializationPromises = initPromise;

        postMessageUtilities.setupStateWatchForReceivedMessages(this._settings, this._store, this.processLaunchIvaMessage.bind(this));
    }

    processLaunchIvaMessage(newVal: LaunchPostMessageObject[]): void {
        const msg = postMessageUtilities.getAndValidateMessage(newVal, 'launchiva') as LaunchPostMessageObject;
        if (!msg) {
            return;
        }

        msg.message.launchType = "Reactive";

        postMessageUtilities.setAccessKey(this._settings, this._store, msg.message);

        const text = msg.message.launchQuestion ?? "";
        const containsText = !!(text && text.trim());

        this.setLaunchParameters(msg.message);

        if (msg.message?.userData) {
            postMessageUtilities.setUserMetadata(this._settings, this._store, msg.message);
        }

        if (msg.message?.language) {
            postMessageUtilities.setLanguage(this._settings, this._store, msg.message);
        }

        if (msg.message?.customSid) {
            this._store?.dispatch(SetCustomSessionId(msg.message.customSid));
        }

        if (containsText && this._settings.welcomeUser.suppressWithLaunchQuestion) {
            this._store?.dispatch(forceIsActiveSession(
                true, this._settings.stateLocations.WelcomeUser.forceIsActiveSession
            ));
        }

        const state = this._store?.getState();

        if (!state?.Conversation?.IsActiveSession) {
            this._store?.dispatch(LaunchIva());
        }
        else{
            const LaunchPointName = msg.message?.launchPointName ?? "";
            if (LaunchPointName !== "" && LaunchPointName !== "Global" 
            && this._settings.welcomeUser.allowActivePonClicks 
            && !state?.WelcomeUser?.SuppressAction?.includes(LaunchPointName)) {
                const input = {
                    messageType: this._settings.messageConstants.appeventRequest,
                    eventName: this._settings.appeventConstants.activeSessionPointOfNeedEventName,
                    origin: this._settings.originConstants.internal,
                    parameters: { LaunchPointName },
                } as AlmeUIInput; 

                sendRequest(input);
            }

         if (state.Window.IsMinimized) {
                    this._store?.dispatch(setMinimize(false, this._settings.stateLocations.Window.IsMinimized));
                }
        }

        this.handleLaunchQuestion(containsText, text);

        postMessageUtilities.setIsProcessed(this._settings, this._store, msg.message);
    }

    setLaunchParameters(message: IvaPostMessage): void
    {
        const launchPointName = message?.launchPointName ?? "";
        const launchParameter = message?.launchParameter ?? "";
        const launchType = message?.launchType ?? "";

        this._store?.dispatch(PrepareLaunchParameters(launchPointName, launchParameter, launchType));
    }

    async handleLaunchQuestion(shouldSend: boolean, question: string): Promise<void>
    {
        if (!shouldSend) { return; }

        await this._initializationPromises.onLaunch;

        const input = {
            text: question,
            messageType: this._settings.messageConstants.converseRequest,
            origin: 'Typed' as const,
        };
        void sendRequest(input);
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/launch-message-processor/src/launch-message-processor.ts